/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestIoTestSubMessageSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_IO_TEST_SUB_MESSAGE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class AutoTestIoTestSubMessageSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestIoTestSubMessageSettingParser.decode(input).map(res => new AutoTestIoTestSubMessageSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestIoTestSubMessageSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestIoTestSubMessageSettingParser.encode(data);
    }
    static schema() {
        return AutoTestIoTestSubMessageSettingParser.schema();
    }
}
